import React, { useEffect, useState } from "react";
import Button from "../../../../components/Button/Button";
import Card from "../../../../components/Card/Card";
import DeleteButton from "../../../../components/DeleteButton/DeleteButton";
import Input from "../../../../components/Input/Input";
import List from "../../../../components/List/List";
import ModalComponent from "../../../../components/Modal/ModalComponent";
import Select from "../../../../components/Select/Select";
import { useListManager } from "../../../../contexts/list.manager";
import VehiclesService from "../../../../services/VehiclesService";
import "../TabsCondoUsers.css";
import "./TabCondoUsersVehicles.css";
import ToolTip from "../../../../components/Tooltip/Tooltip";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import { NotificationManager } from "react-notifications";
import { CREDENTIAL_TYPE_NAMES } from "../../../../constants/credentials";
import { MdEdit } from "react-icons/md";
import { joinWithCommaAnd } from "../../../../utils/string";

const TabCondoUsersVehicles = (props) => {
	const [condoUserVehicles, setCondoUserVehicles] = useState([]);
	const [showModalAdd, setShowModalAdd] = useState(false);
	const [showModalCredentials, setShowModalCredentials] = useState(false);
	const [model, setModel] = useState("");
	const [brand, setBrand] = useState("");
	const [licensePlate, setLicensePlate] = useState("");
	const [color, setColor] = useState("");
	const [mode, setMode] = useState("");
	const [licenses, setLicenses] = useState([]);
	const [credentialSelected, setCredentialSelected] = useState("");
	const [closeCard, setCloseCard] = useState(false);
	const [credentials, setCredentials] = React.useState([]);
	const [optionsCredentials, setOptionsCredentials] = React.useState([]);
	const { lineSelected, closeForm } = useListManager();

	const getCondoUserVehicles = async (condoUser) => {
		if (!condoUser.id) return;
		const response = await VehiclesService.listVehiclesByCondoUser(
			condoUser.id,
		);
		return response.data;
	};

	function getCredentialDescription(credential) {
		if (!credential) return "";
		return ([2, 3].includes(credential.type) ? credential.code.replace(/./g, '*') : credential.code) + ` (${CREDENTIAL_TYPE_NAMES[credential.type]})`;
	}

	const storeCondoUserCredentials = (credentials) => {
		if (!credentials) return;
		let options = [];
		credentials?.forEach((credential) => {
			options.push({
				value: credential.id ?? credential.uuid,
				text: getCredentialDescription(credential)
			});
		});
		setCredentials(credentials);
		setOptionsCredentials(options);
	};

	useEffect(() => {
		(async () => {
			let vehicles = props.vehicles;
			if (props.condoUser) {
				const loadedVehicles = await getCondoUserVehicles(props.condoUser);
				vehicles = vehicles.map(vehicle => ({
					...vehicle,
					licenses: vehicle.licenses ?? loadedVehicles.find(v => v.id === vehicle.id)?.licenseIds?.map(id => ({ id })),
					credential: vehicle.credential ?? loadedVehicles.find(v => v.id === vehicle.id)?.credential,
				}));
			}
			setCondoUserVehicles(vehicles ?? []);
			storeCondoUserCredentials(props.credentials);
		})();
	}, [props.vehicles, props.credentials]);

	const buildPayload = () => {
		let payload = {
			model: model,
			brand: brand,
			license_plate: licensePlate,
			color: color,
			licenses,
		};
		return payload;
	};

	function validateVehicle(payload) {
		if (!payload.license_plate) {
			NotificationManager.warning(
				"Placa é obrigatória",
				"Atenção!",
			);
			return false;
		}
		if (!payload.model) {
			NotificationManager.warning(
				"Modelo é obrigatório",
				"Atenção!",
			);
			return false;
		}
		if (!payload.brand) {
			NotificationManager.warning(
				"Marca é obrigatória",
				"Atenção!",
			);
			return false;
		}
		return true;
	}

	function saveNewVehicles() {
		const payload = buildPayload();
		if (!validateVehicle(payload)) return;
		if (condoUserVehicles.find(v => v.license_plate === payload.license_plate)) {
			NotificationManager.warning(
				"Veículo já cadastrado",
				"Atenção!",
			);
			return;
		}
		setCondoUserVehicles((prevVehicles) => [...prevVehicles, payload]);
		const newCondoUserVehicles = [...condoUserVehicles, payload];
		props.handleChangeVehicles(newCondoUserVehicles);
	}

	function editVehicles(credentialFound) {
		const indexToUpdate = condoUserVehicles.findIndex(
			(vehicle) => vehicle.id === lineSelected?.id,
		);
		if (indexToUpdate === -1) return;
		let updatedPayload = {};

		if (credentialFound) {
			updatedPayload = {
				...condoUserVehicles[indexToUpdate],
				credential: credentialFound,
			};
		} else {
			updatedPayload = {
				...condoUserVehicles[indexToUpdate],
				model: model,
				brand: brand,
				license_plate: licensePlate,
				color: color,
				licenses,
			};
		}
		if (!validateVehicle(updatedPayload)) return;
		if (condoUserVehicles.find(v => v.license_plate === updatedPayload.license_plate && v.id !== updatedPayload.id)) {
			NotificationManager.warning(
				"Veículo já cadastrado",
				"Atenção!",
			);
			return;
		}
		const updatedCondoUserVehicles = condoUserVehicles.map((item, index) => {
			if (index === indexToUpdate) {
				return updatedPayload;
			}
			return item;
		});
		setCondoUserVehicles(updatedCondoUserVehicles);
		props.handleChangeVehicles(updatedCondoUserVehicles);
	}

	function editCredentials() {
		let credentialFound = credentials.find(
			(credential) => credential.id === parseInt(credentialSelected) || credential.uuid === credentialSelected,
		);
		if (credentialFound) {
			editVehicles(credentialFound);
		}
	}

	function removeVehicles(item) {
		const indexToRemove = condoUserVehicles.findIndex(
			(i) => i === item,
		);
		if (indexToRemove !== -1) {
			const updatedCondoUserVehicles = [
				...condoUserVehicles.slice(0, indexToRemove),
				...condoUserVehicles.slice(indexToRemove + 1),
			];
			setCondoUserVehicles(updatedCondoUserVehicles);
			props.handleChangeVehicles(updatedCondoUserVehicles);
			closeForm();
		}
		closeForm();
	}

	const handleClickModalButton = async (action) => {
		if (action === "confirm") {
			if (mode === "add") saveNewVehicles();
			if (mode === "edit") editVehicles();
			if (mode === "credentials") editCredentials();
		}
		setModel("");
		setBrand("");
		setLicensePlate("");
		setColor("");
		setLicenses([]);
		setShowModalAdd(false);
		setShowModalCredentials(false);
		closeForm();
	};

	const handleClickAdd = async () => {
		setMode("add");
		setShowModalAdd(true);
	};

	const handleClickEdit = async (row) => {
		const item = row ?? lineSelected;
		if (!item) return;
		setMode("edit");
		setModel(item.model);
		setBrand(item.brand);
		setLicensePlate(item.license_plate);
		setColor(item.color);
		setLicenses(item.licenses);
		setShowModalAdd(true);
	};

	const handleClickCredentials = async (row) => {
		const item = row ?? lineSelected;
		if (!item) return;
		setCloseCard(!closeCard);
		setMode("credentials");
		setCredentialSelected(item.credential?.id);
		setShowModalCredentials(true);
	};

	const handleClickRemove = async (row) => {
		const item = row ?? lineSelected;
		if (!item) return;
		removeVehicles(item);
	};

	const handleClickUnlinkCredential = async (row) => {
		const item = row ?? lineSelected;
		if (!item) return;
		const indexToUpdate = condoUserVehicles.findIndex(
			(vehicle) => vehicle === item,
		);
		if (indexToUpdate === -1) return;

		const updatedPayload = {
			...condoUserVehicles[indexToUpdate],
			credential: [],
		};

		const updatedCondoUserVehicles = condoUserVehicles.map((item, index) => {
			if (index === indexToUpdate) {
				return updatedPayload;
			}
			return item;
		});

		setCondoUserVehicles(updatedCondoUserVehicles);
		props.handleChangeVehicles(updatedCondoUserVehicles);
	};

	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			<div className="w-full">
				<div className="tab-condo-users-buttons-container">
					<div className="tab-condo-users-buttons">
						<Button
							action="add"
							className="tab-condo-users-add button-white w-[180px]!"
							label="Adicionar Veículo"
							onClick={() => handleClickAdd()}
						/>
					</div>
					{lineSelected &&
						lineSelected.credential &&
						lineSelected.credential.id ? (
						<Button
							className="button-red tab-condo-users-desvincular-visibility"
							label="Desvincular credencial"
							onClick={() => handleClickUnlinkCredential()}
						/>
					) : (
						<Button
							className="button-white tab-condo-users-buttons-visibility"
							label="Credenciais"
							onClick={() => handleClickCredentials()}
						/>
					)}
				</div>
				<div className="list-visibility w-full">
					<List
						collumsObjIndex={[
							{ collumnLabel: "Modelo", index: "model", type: "text" },
							{ collumnLabel: "Marca", index: "brand", type: "text" },
							{ collumnLabel: "Placa", index: "license_plate", type: "text" },
							{ collumnLabel: "Cor", index: "color", type: "text" },
							{ collumnLabel: "Credencial", index: "credential", custom: ({ row }) => getCredentialDescription(row.credential) },
							{
								collumnLabel: "Licenças", index: "licenses", custom: ({ row }) => {
									return joinWithCommaAnd(row.licenses?.map(l => {
										return props.condoUserLicenses?.find(l2 => l2.license.id === l.id)?.ownerUnit?.name;
									})?.filter(n => n))
								}
							},
							{
								collumnLabel: "Ações", type: "actions", custom: ({ row }) => {
									return (
										<div className="flex justify-end gap-4">
											<button type="button" className={`cursor-pointer hover:opacity-70 duration-100`} onClick={e => {
												handleClickEdit(row);
											}}>
												<MdEdit size={18} />
											</button>
											<DeleteButton
												className="button-white tab-condo-users-buttons-visibility"
												handleDelete={() => handleClickRemove(row)}
												simple
											/>
										</div>
									);
								}
							},
						]}
						data={condoUserVehicles}
					/>
				</div>
				<div className="card-visibility">
					{condoUserVehicles?.length > 0 ? (
						condoUserVehicles.map((vehicle, index) => (
							<Card
								key={index}
								data={vehicle}
								delete={() => handleClickRemove()}
								edit={() => handleClickEdit()}
								closeCard={closeCard}
								aditionalButton1={
									<Button
										className="button-blue"
										label="Credenciais"
										onClick={() => handleClickCredentials()}
									/>
								}
							>
								<p className="card-content-title">{vehicle.model}</p>
								<p className="card-content">Marca: {vehicle.brand}</p>
								<p className="card-content">Modelo: {vehicle.license_plate}</p>
								<p className="card-content">Cor: {vehicle.color}</p>
							</Card>
						))
					) : (
						<div
							style={{
								marginTop: "10px",
								backgroundColor: "var(--textColor)",
								padding: "10px",
								textAlign: "center",
							}}
						>
							Nenhum registro encontrado.
						</div>
					)}
				</div>
				<ModalComponent
					modalIsOpen={showModalAdd}
					handleConfirm={() => handleClickModalButton("confirm")}
					handleCancel={() => handleClickModalButton("cancel")}
					modalText={"Adicionar veículo"}
					buttonLabel1={"Confirmar"}
				>
					<div className="modal-vehicles">
						<Input
							name="model"
							id="model"
							labelText={"Modelo"}
							value={model}
							onChange={({ target }) => setModel(target.value)}
							tooltipText="Modelo do veículo"
							tooltipVisible={true}
						/>
						<Input
							name="brand"
							id="brand"
							labelText={"Marca"}
							value={brand}
							onChange={({ target }) => setBrand(target.value)}
							tooltipText="Marca do veículo"
							tooltipVisible={true}
						/>
						<Input
							name="license_plate"
							id="license_plate"
							labelText={"Placa"}
							value={licensePlate}
							onChange={({ target }) => {
								let val = target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
								if (val.length > 3) {
									val = val.slice(0, 3) + "-" + val.slice(3);
								}
								setLicensePlate(val);
							}}
							tooltipText="Placa do veículo"
							tooltipVisible={true}
							pattern="[A-Z]{3}-[0-9]{4}"
							title="Formato esperado: ABC-1234"
							placeholder="ABC-1234"
							maxLength={8}
						/>
						<Input
							name="color"
							id="color"
							labelText={"Cor"}
							value={color}
							onChange={({ target }) => setColor(target.value)}
							tooltipText="Cor do veículo"
							tooltipVisible={true}
						/>
						<div className="w-full">
							<p style={{ display: 'flex', gap: '5px', fontSize: '14px', textAlign: 'left', color: 'var(--textColor)', marginBottom: 5 }}>
								<span>Licenças</span>
								<ToolTip
									tooltipVisible={true}
									tooltipText={"Selecione as licenças para as quais esta credencial deve ser enviada."}
								/>
							</p>
							{props.condoUserLicenses?.length > 0 ? (
								<div className="flex justify-start gap-4">
									{props.condoUserLicenses.map(l => (
										<Checkbox
											name={`licenses${l.id}`}
											style={{ width: "fit-content" }}
											labelText={l.ownerUnit.name}
											checked={licenses.some(l2 => l2.id === l.license.id)}
											onChange={({ target }) => {
												setLicenses(prevLicenses => {
													let _licenses = [...prevLicenses];
													if (target.checked) {
														if (!_licenses.find(pl => pl.id === l.license.id)) {
															_licenses.push({ id: l.license.id });
														}
													} else {
														_licenses = _licenses.filter(pl => pl.id !== l.license.id);
													}
													return _licenses;
												});
											}}
											required={false}
										/>
									))}
								</div>
							) : (
								<p className="text-sm! text-left text-(--textColor) mb-1! opacity-40">
									Nenhuma licença vinculada para este usuário
								</p>
							)}
						</div>
					</div>
				</ModalComponent>
				<ModalComponent
					modalIsOpen={showModalCredentials}
					handleConfirm={() => handleClickModalButton("confirm")}
					handleCancel={() => handleClickModalButton("cancel")}
					modalText={"Adicionar credencial ao veículo"}
					buttonLabel1={"Salvar"}
				>
					<Select
						labelText="Credencial do Veículo"
						value={credentialSelected}
						onChange={({ target }) => setCredentialSelected(target.value)}
						disabled={props.type === "consulta"}
						required={true}
						options={optionsCredentials}
					/>
				</ModalComponent>
			</div>
		</div>
	);
};

export default TabCondoUsersVehicles;
